import { route, type RoutableProps } from "preact-router";
import { useEffect } from "preact/hooks";
import { SignIn, useAuth } from "../../auth/clerk";
import { Navbar } from "../../components/layout/Navbar";

/**
 * Login page powered by Clerk's hosted SignIn component.
 * Clerk handles both sign-in and sign-up in a single view.
 *
 * Guard: if the user already has an active Clerk session when landing on this
 * page, redirect to home immediately.  This prevents Clerk from auto-navigating
 * into a "choose-organization" sub-route that preact-router doesn't handle
 * (e.g. /login/tasks/choose-organization), which would show a 404.
 * Organization selection stays available via the navbar switcher for
 * already-authenticated users.
 */
export function LoginPage(_props: RoutableProps) {
  const { isLoaded, isSignedIn } = useAuth();

  useEffect(() => {
    if (isLoaded && isSignedIn) {
      route("/");
    }
  }, [isLoaded, isSignedIn]);

  // While Clerk is loading or we are about to redirect, show the shell without
  // the SignIn component so it won't trigger its internal redirect.
  if (!isLoaded || isSignedIn) {
    return (
      <div class="app-shell">
        <Navbar />
        <main class="login-main">
          <div class="login-card">
            <div class="login-header">
              <h1 class="login-title">Log in to Sage</h1>
              <p class="login-desc">Access your reports, API keys, and workspace.</p>
            </div>
          </div>
          <p class="login-note">
            Sage hash reputation &middot; SOC intelligence console
          </p>
        </main>
      </div>
    );
  }

  return (
    <div class="app-shell">
      <Navbar />

      <main class="login-main">
        <div class="login-card">
          <div class="login-header">
            <h1 class="login-title">Log in to Sage</h1>
            <p class="login-desc">Access your reports, API keys, and workspace.</p>
          </div>

          <SignIn
            routing="virtual"
            afterSignInUrl="/"
          />
        </div>

        <p class="login-note">
          Sage hash reputation &middot; SOC intelligence console
        </p>
      </main>
    </div>
  );
}
